
/**
 * Expose the wildcard disposable domains.
 */

module.exports = require('./wildcard.json');
